import {TriangleDownIcon} from '@primer/octicons-react'
import {Stack, Token} from '@primer/react'
import type {ComponentProps, ComponentType, RefObject} from 'react'

import styles from './AgentTasksToken.module.css'
import {TASK_NOUN} from '../utils/constants'

type AgentTasksTokenProps = {
  icon: ComponentType
  iconColor: string
  label: string
  onClick?: ComponentProps<typeof Token>['onClick']
  isSticky?: boolean
  buttonRef?: RefObject<HTMLElement | null>
}

export function AgentTasksToken({
  icon: Icon,
  iconColor,
  label,
  onClick,
  isSticky,
  buttonRef,
  ...props
}: AgentTasksTokenProps) {
  return (
    <Token
      ref={buttonRef}
      as="button"
      aria-label={`Agent ${TASK_NOUN}s: ${label}`}
      className={styles.token}
      text={
        <Stack direction="horizontal" align="center" gap={'condensed'}>
          <span style={{color: iconColor}} aria-hidden="true">
            <Icon />
          </span>
          <span>{label}</span>
          <span className={styles.tokenCaret} aria-hidden="true">
            <TriangleDownIcon size={12} />
          </span>
        </Stack>
      }
      size={isSticky ? 'large' : 'xlarge'}
      onClick={onClick}
      {...props}
    />
  )
}
